<template >
  <div
    class="book-tool"
    :class="[this.isOpen ? 'book-tool--open' : 'book-tool--closed', this.crossingElement ? 'contrast' : '']"
    ref="bookTool"
  >
    <div class="book-tool__btn" @click="toggle()" :class="this.themeSite">
      <span>
        <div class="book-tool__btn-inner">{{ translations.bookRoom }}</div>
      </span>
    </div>

    <div v-if="this.isOpen" class="book-tool__popout-mobile" :class="this.themeSite">
      <radio-list-mobile
        v-if="this.isOpen"
        :translations="translations"
        :location-options="locationOptions"
        :themeSite="themeSite"
        class="mr4"
      >
        <template v-slot:trigger>
          <div class="bb bw1 b--white h-48px flex items-center" :class="`hover-b--${themeSite}`">
            <button class="bg-transparent bn outline-0 pointer">
              {{ locationValue }}
              <span>
                <svg
                  class="v-mid"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                >
                  <defs>
                    <path id="a" d="M17 15h4v2h-4v4h-2v-4h-4v-2h4v-4h2v4z" />
                  </defs>
                  <g fill="none" fill-rule="evenodd">
                    <mask id="b" fill="#fff">
                      <use xlink:href="#a" />
                    </mask>
                    <use fill="#D8D8D8" xlink:href="#a" />
                    <g :fill="themeColor" mask="url(#b)">
                      <path d="M0 0h32v32H0z" />
                    </g>
                  </g>
                </svg>
              </span>
            </button>
          </div>
        </template>
      </radio-list-mobile>
    </div>
  </div>
</template>

<script>
import s from "../store"
import h from "../helpers"
import RadioListMobile from "./RadioListMobile"

export default {
  name: "BookToolMobile",

  components: {
    RadioListMobile
  },

  data: function() {
    return {
      sharedState: s.state,
      crossingElement: false,
      touched: false,
      isOpen: false,
      collapsedX: null,
      collapsedY: null,
      borderRadius: 46,
      collapsedBorderRadius: null,
      submitValue: null,
      locationOptions: null
    }
  },

  props: {
    showLocation: {
      type: Boolean,
      default: false
    },
    themeSite: {
      type: String,
      default: "portal"
    },
    translations: { type: Object }
  },

  created: function() {
    this.locationOptions = s.static.synxisLocations

    if (!this.showLocation) {
      s.setBookingScriptSettings(this.sharedState.activeHotel)
    }
  },

  mounted: function() {
    if (s.debug) console.log("init BookToolMobile")
    // init pagePositionDetector
    this.pagePositionDetector()
  },

  watch: {
    isOpen(isOpen) {
      if (isOpen) {
        document.addEventListener("click", this.closeIfClickedOutside)
      }
    }
  },

  computed: {
    bookingParams: function() {
      if (this.isMobile) {
        if (s.debug)
          console.log(
            "h.serializeObject(s.state.booking)",
            h.serializeObject(s.state.booking)
          )
        return h.serializeObject(s.state.booking)
      } else {
        return ""
      }
    },

    locationValue: function() {
      return s.getLocation(s.state.booking.hotel) || this.translations.location
    },

    isMobile: function() {
      return window.innerWidth < 960
    }
  },

  methods: {
    onScroll(event) {
      // Close book tool when the users scrolls
      window.removeEventListener("scroll", this.onScroll)
      this.close()
    },

    onResize(event) {
      // Implement on resize
      if (this.isMobile) {
        return
      }
    },

    closeIfClickedOutside(event) {
      if (!event.target.closest(".book-tool")) {
        document.removeEventListener("click", this.closeIfClickedOutside)
        this.close()
      }
    },

    open: function(event) {
      this.isOpen = true
    },

    close: function() {
      this.isOpen = false
    },

    toggle: function() {
      this.isOpen = !this.isOpen
    },

    isInElement(buttonEl, targetEls) {
      const fixed_position =
        buttonEl.getBoundingClientRect().top + window.scrollY
      const fixed_height = buttonEl.offsetHeight

      this.crossingElement = false
      for (let i = 0; i < targetEls.length; i++) {
        const el = targetEls[i]
        const toCross_position = el.offsetTop
        const toCross_height = el.offsetHeight

        if (fixed_position + fixed_height < toCross_position) {
        } else if (fixed_position > toCross_position + toCross_height) {
        } else {
          this.crossingElement = true
        }
      }
    },

    pagePositionDetector() {
      this.$nextTick(() => {
        let els = document.querySelectorAll("[data-detect-section]")

        const buttonEl = this.$refs.bookTool
        const _self = this
        if (els.length > 0) {
          if (s.debug) console.log(els)

          window.addEventListener(
            "scroll",
            function(event) {
              _self.isInElement(buttonEl, els)
            },
            false
          )
        }
      })
    }
  }
}
</script>

<style>
.hover-b--yellow {
  transition: border-color 250ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
}

.hover-b--yellow:hover,
.hover-b--yellow:focus,
.hover-b--yellow:active {
  border-color: #e1a724;
}

.dropdown__toggle[aria-expanded="true"] .hover-b--yellow {
  border-color: #e1a724;
}
</style>
